<template>
  <div>
    <div class="order-main">
      <div class="order-first-div" style="background-color: white">
        <div>
          <span style="color: #333333;margin-left: 10px;line-height: 26px;">目标店铺</span>
        </div>
        <div>
          <span style="color: orangered;line-height: 26px;">{{ taskCommon.reviewShopName }}</span>
        </div>
      </div>
      <!--<van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <div class="order-first-div" style="background-color: white">
        <div>
          <span style="color: #333333;margin-left: 10px;line-height: 26px;">目标商品</span>
        </div>
      </div>
      <div v-for="(cardataItem, index) in cardData.taskOrderDetailGoodsVos" :key="index">
        <van-card
            :thumb="cardataItem.thumbUrl">
          <template #tags>
            <div class="end-box">
              <div class="leftArea" style="font-size: small">
                <div>搜索展示价格：<span style="color: #4d84e2">{{ cardataItem.showPrice }}</span> 元</div>
                <div v-if="cardataItem.isMainGood" style="margin-top: 2px;">当前销量：<span style="color: #4d84e2">{{ cardataItem.getGoodsPersons }}</span> 件
                </div>
                <div style="margin-top: 3px;">商品单价：<span style="color: red">{{ cardataItem.buyPrice }}</span>元</div>
                <div style="margin-top: 3px;">购买数量：<span style="color: red">{{ cardataItem.buyNumbers }}</span>件</div>
              </div>
            </div>
          </template>
        </van-card>
      </div>-->
      <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <div class="order-first-div" style="background-color: gray">
        <div style="margin: 10px;">
          <van-icon name="star"/>
          <span>任务要点</span>
        </div>
      </div>
      <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <div class="order-first-div" style="background-color: white">
        <div style="color: orangered;line-height: 26px;margin-left: 10px">
          <span>请按照任务要求认真评价和截图</span>
        </div>
      </div>
      <van-list class="step-body">
        <van-cell title="订单编号：" :value="taskCommon.orderNum"></van-cell>
        <van-cell title="任务类型：" :value="taskCommon.taskType"></van-cell>
        <van-cell title="平台订单号：" :value="taskCommon.plateformNumber"></van-cell>
      </van-list>
      <div class="order-first-div" style="background-color: gray">
        <div style="margin: 10px;">
          <van-icon name="star"/>
          <span>注意事项</span>
        </div>
      </div>
      <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <div class="order-first-div" style="background-color: white">
        <div style="color:black;line-height: 33px;margin-left: 10px">
          <span>评价内容中切记不要出现 "任务， 做单， 种菜" 等词汇。</span>
        </div>
      </div>
      <van-list class="step-body">
        <van-cell>
          <template #title>
            <span style="color: red;">1: 五星+15个字左右好评</span>
          </template>
        </van-cell>
        <van-cell>
          <template #title>
            <span style="color: red;">2: 根据任务类型，按照商家要求评价。</span>
          </template>
        </van-cell>
        <van-cell>
          <template #title>
            <span style="color: red;">3: 提交前和提交后截图。</span>
          </template>
        </van-cell>
      </van-list>
      <div class="order-first-div" style="background-color: gray">
        <div style="margin: 10px;">
          <van-icon name="star"/>
          <span>任务步骤</span>
        </div>
      </div>
      <van-divider style="color: #4d84e2;margin: 5px;"></van-divider>
      <div class="order-first-div" style="background-color: white">
        <div style="color: #5995fd;line-height: 44px;margin-left: 10px;">
          <span>第一步：确认订单及评论信息</span>
        </div>
      </div>
      <van-list class="step-body">
        <van-cell>
          <template #title>
            <span >1, 请确认使用的账户<span
                style="color: red;background-color: cornflowerblue;margin: 2%;width: 2rem;">{{ taskCommon.accountName }}</span>账号登录</span>
          </template>
        </van-cell>
        <van-cell>
          <template #title>
            <span>2, 找到订单
              <span style="color: red">{{taskCommon.plateformNumber}}</span>
              ，确认首次评价内容。
            </span>
            <br>
            <van-button type="info" size="mini"
                        v-clipboard:copy="taskCommon.plateformNumber"
                        v-clipboard:success="onCopy"
                        v-clipboard:error="onError">点击复制订单号
            </van-button>
          </template>
        </van-cell>
      </van-list>
      <div class="order-first-div" style="background-color: white">
        <div style="color: #5995fd;line-height: 44px;margin-left: 10px;font-size: small">
          <span>第二步：订单追加评价</span>
        </div>
      </div>
      <van-list>
        <van-cell>
          <template #title>
            <span v-if="reviewConditionInfo.taskClass=='20210001'">
              1, 普通任务，
              <span v-if="reviewConditionInfo.isOnlyEvaluate" style="color: orangered">只需要五星好评,不需要文字评论。</span>
              <span v-else>请按照平时购买习惯，提交15个字左右的有字评价即可</span>
            </span>
            <span v-else-if="reviewConditionInfo.taskClass=='20210002'">
              1, 指定文字好评任务，
              <span>指定文字：<br><span style="color: red;">{{reviewConditionInfo.reviewContent}}</span></span>
               <van-button type="info" size="mini"
                           v-clipboard:copy="reviewConditionInfo.reviewContent"
                           v-clipboard:success="onCopy"
                           v-clipboard:error="onError">点击复制
               </van-button>
            </span>
            <span v-else-if="reviewConditionInfo.taskClass=='20210003'">
              1, 指定图片好评任务，
              <span>指定文字：<br><span style="color: red;">{{reviewConditionInfo.reviewContent}}</span></span>
              <van-button type="info" size="mini"
                          v-clipboard:copy="reviewConditionInfo.reviewContent"
                          v-clipboard:success="onCopy"
                          v-clipboard:error="onError">点击复制
              </van-button>
              <br/>
              <span>指定图片：
                <br/>
                <div v-for="item in reviewConditionInfo.imageListUrls" :key="index" style="width: 100%;text-align: center">
                 <van-image
                     width="15rem"
                     height="15rem"
                     lazy-load
                     @click="perviewImage(item)"
                     fit="cover"
                     :src="item"></van-image>
                  <br>
                    <van-button @click="savePicture(item)" style="margin-bottom: 2%;">点击下载</van-button>
                  </div>
              </span>
            </span>
            <span v-else-if="reviewConditionInfo.taskClass=='20210004'">
              1, 指定视频好评任务，
              <span>指定文字：<br><span style="color: red;">{{reviewConditionInfo.reviewContent}}</span></span>
              <van-button type="info" size="mini"
                          v-clipboard:copy="reviewConditionInfo.reviewContent"
                          v-clipboard:success="onCopy"
                          v-clipboard:error="onError">
                点击复制
              </van-button>
              <br/>
              <span>指定视频：
                <br/>
                <video autoplay :src="reviewConditionInfo.videoUrls" controls="controls" width="100%" height="300px"></video>
                <br/>
                <van-button @click="savePicture(reviewConditionInfo.videoUrls)" style="margin-bottom: 2%;">点击下载</van-button>
              </span>
              <br/>
              <span>指定图片：
                <br/>
                <div v-for="item in reviewConditionInfo.imageListUrls" :key="index" style="width: 100%;text-align: center">
                <van-image  width="15rem"
                            height="15rem"
                            lazy-load
                            @click="perviewImage(item)"
                            fit="cover"
                            :src="item"></van-image>
                  <br/>
                  <van-button @click="savePicture(item)" style="margin-bottom: 2%;">点击下载</van-button>
                  </div>
              </span>
            </span>
          </template>
        </van-cell>
      </van-list>
      <div class="order-first-div" style="background-color: white">
        <div style="color: #5995fd;line-height: 44px;margin-left: 10px;font-size: small">
          <span>第三步：截图上传</span>
        </div>
      </div>
      <van-list>
        <van-cell>
          <template #title>
            <span>1, 将评价过程的截图上传</span>
          </template>
        </van-cell>
      </van-list>
      <div class="order-first-div" style="background-color: white">
        <div style="color: orangered;line-height: 26px;margin-left: 10px">
          <span><van-icon name="browsing-history-o"/>评价截图(至少上传一张)</span>
        </div>
      </div>
      <van-row :gutter="0" style="background-color: white">
        <div style="margin: 2%;padding-top: 2%;" ref="imgHeight">
          <van-col :span="11">
            <van-field name="IdCardBUrl">
              <template #input>
                <van-uploader accept="image/*" :max-count="1" v-model="image1File" :after-read="afterImages">
                </van-uploader>
              </template>
            </van-field>
          </van-col>
          <van-col :span="2" :style="{height:imgHeight}">
            <div :style="{padding:'16px 6px 1px', marginLeft:'12px', borderLeft:'1px solid', fontSize: '0', minHeight:imgHeight+'px'}"></div>
          </van-col>
          <van-col :span="11">
            <van-field name="IdCardBUrl">
              <template #input>
                <van-uploader accept="image/*" :max-count="1" v-model="image2File" :after-read="afterImages">
                </van-uploader>
              </template>
            </van-field>
          </van-col>
        </div>
      </van-row>
      <van-row :gutter="0" style="background-color: white">
        <div style="margin: 2%;padding-top: 2%;">
          <van-col :span="11">
            <van-field name="IdCardBUrl">
              <template #input>
                <van-uploader accept="image/*" :max-count="1" v-model="image3File" :after-read="afterImages">
                </van-uploader>
              </template>
            </van-field>
          </van-col>
          <van-col :span="2" :style="{}">
            <div :style="{padding:'16px 6px 1px', marginLeft:'12px', borderLeft:'1px solid', fontSize: '0', minHeight:imgHeight+'px'}"></div>
          </van-col>
          <van-col :span="11">
            <van-field name="IdCardBUrl">
              <template #input>
                <van-uploader accept="image/*" :max-count="1" v-model="image4File" :after-read="afterImages">
                </van-uploader>
              </template>
            </van-field>
          </van-col>
        </div>
      </van-row>
      <van-row :gutter="0" style="background-color: white">
        <div style="margin: 2%;padding-top: 2%;">
          <van-col :span="11">
            <van-field name="IdCardBUrl">
              <template #input>
                <van-uploader accept="image/*" :max-count="1" v-model="image5File" :after-read="afterImages">
                </van-uploader>
              </template>
            </van-field>
          </van-col>
        </div>
      </van-row>
      <div class="order-first-div" style="background-color: white; padding: 2%; width: 100%; text-align: center">
        <van-button type="info" size="large" @click="commitTaskOperInfo">提交追评信息</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  commitExtraReviewOperInfo,
  getTaskCommont,
  queryExtraReviewCondition,
} from "../../api/system/mobile_taskorder";
import {MessageBox} from "mint-ui";
import {getTokenUser} from "../../lib/utils";
import {ImagePreview, Toast} from "vant";
import {uploaderToServer} from "../../api/system/sys_backInfo";
import Expand from "../../lib/expand";

export default {
name: "ExtraReviewOperation",
  data(){
    return {
      exjs: null,
      goodsLink:"",
      shopName:"",
      iconUrl: "cart-circle-o",
      orderStatus: "待操作-核对店名",
      cardData: {
      },
      reviewConditionInfo:{
      },
      taskCommon:{},
      accountName:"",
      image1File:[],
      image2File:[],
      image3File:[],
      image4File:[],
      image5File:[],
      imageUrls:[],
      b2cOperationTaskResult: {},
      list:[
        {
          orderKey:"买号",
          orderVal: "Love2106868"
        },
      ],
      loading: false,
      finished: false,
      imgHeight:120
    }
  },
  mounted() {
    this.$emit("titleChange", "追加评价");
    this.cardData = this.$route.query;
    console.log(this.cardData);
    getTaskCommont(this.cardData).then(res=>{
      console.log(res.data)
      if (res.success){
        this.taskCommon = res.data;
        queryExtraReviewCondition(this.taskCommon.orderId).then(res1=>{
          if (res1.success){
            this.reviewConditionInfo = res1.data;
          }
        }).catch(err => {
          MessageBox({
            title: '提示',
            message: err.message
          });
        });
      }
    }).catch(err => {
      MessageBox({
        title: '提示',
        message: err.message,
        showCancelButton: true
      });
    });

    this.accountName = getTokenUser();
    this.imgHeight = 225;
  },
  methods:{
    onCopy(e) {
      //alert('复制成功！: ' + e.text)
      Toast.success("复制成功！");
    },
    onError(e) {
      Toast.fail('你的浏览器不支持复制拷贝！')
    },
    perviewImage(imgUrl){
      ImagePreview({
        images: [
          imgUrl
        ],
        closeable: true,
      });
    },
    afterImages(file){
      let tempFile = file.file;
      let type = tempFile.type;
      let size = tempFile.size;
      let newName = new Date().getTime() + tempFile.name;
      let uploadFile = new File([tempFile], newName, {type, size});
      let formData = new FormData();

      file.status = 'uploading';
      file.message = "上传中....";

      formData.append('file', uploadFile);
      uploaderToServer(formData).then(res=>{
        if (res.success){
          file.status = 'success';
          file.message = '上传成功';
          this.imageUrls.push(res.data);
        }
      });
    },
    commitTaskOperInfo(){
      if (this.imageUrls.length > 0){
        commitExtraReviewOperInfo({orderId:this.$route.query.orderId, imageUrls:this.imageUrls.toString()}).then(res=>{
          if (res.success){
            this.$router.push({path: '/home/usertaskmgelist'});
          }
        }).catch(err => {
          MessageBox({
            title: '提示',
            message: err.message,
            showCancelButton: true
          });
        });
      }else{
        MessageBox({
          title: '提示',
          message: "请确认至少上传一张图片！",
          showCancelButton: true
        });
      }
    },
    //保存网络的图片到手机相册
    savePicture(Url){
      if(window.plus){
        plusReady();
      }else{
        document.addEventListener('plusready', plusReady, false);
      }

      async function plusReady(){
        console.log("已经加载plusReady");
        try {
          await new Expand().saveImgToLocal({path: Url});
          Toast.success("下载成功！");
        }catch (e) {
          Toast.fail("下载失败！");
          console.log(JSON.stringify(e))
        }
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.order-main {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  margin-left: 1%;
  width: 98%;

  .order-first-div {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    background-color:#FF6699;
    font-size: small;
    color: white;
  }

  .end-box{
    font-size: small;
  }

  ::v-deep .van-uploader__upload{
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    flex-direction: column;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    box-sizing: border-box;
    width: 128px;
    height: 225px;
    margin: 0 8px 8px 0;
    background-color: #f7f8fa;
  }

  ::v-deep .van-uploader__preview-image{
    display: block;
    width: 128px;
    height: 225px;
    overflow: hidden;
  }
}
</style>
